import _ from 'lodash';
import React from 'react';
import { colours } from '../../../styles/colours';
import DateLabel from '../../general/date/date-label';
import DatePicker from '../../general/date/date-picker';
import { ClinicalBaseControl } from '../clinical-base-control';
import ReadOnly from '../read-only';

export interface IProps {
  errored?: boolean;
  inline?: boolean;
  label?: React.ReactNode;
  placeholder?: React.ReactNode;
  readOnly?: boolean;
  restrictFutureDate?: boolean;
  tabIndex: number;
  warning?: boolean;
}

export default ClinicalBaseControl(
  class ClinicalDatePicker extends React.Component<IProps> {
    getDefaultProp = () => {
      return { tabIndex: 1 };
    };

    onClick = (e) => {
      return this.input.focus(e);
    };

    render() {
      let control, label, value;
      if (this.props.readOnly) {
        ({ value } = this.props);
        control = (
          <ReadOnly
            forceNotSpecified={!value}
            isDate={true}
            value={React.createElement(DateLabel, {
              value: value,
              skipUtc: true
            })}
          />
        );
      } else {
        const style: React.CSSProperties = {}; // {background:'#DDEAF6', borderColor:'#B6D3EC'}
        const labelStyle: React.CSSProperties = { fontWeight: 'normal' }; // {color:'#1E4E79', fontWeight:'bold'}

        style.textTransform = 'capitalize';

        if (this.props.errored) {
          style.background = colours.red200;
          style.background = colours.red400;
          style.color = `${colours.red} !important`;
        } else if (this.props.warning && this.props.value == null) {
          style.background = colours.orange100;
          style.borderColor = colours.orange300;
          style.color = `${colours.orange300} !important`;
        }

        control = (
          <DatePicker
            {...this.props}
            value={this.props.value}
            style={style}
            ref={(ref) => (this.input = ref)}
            labelStyle={labelStyle}
            label={this.props.placeholder || 'Select a Date'}
            tabIndex={this.props.tabIndex}
            displayMode={this.props.displayMode}
            minYear={this.props.minYear}
            maxYear={this.props.maxYear}
            wrapperStyle={{ marginTop: -6 }}
            restrictFutureDate={this.props.restrictFutureDate}
          />
        );
      }

      if (!this.props.inline) {
        label = (
          <span
            style={{ color: colours.lightBlue, fontSize: 16, display: 'block' }}
            onClick={this.onClick}
          >
            {this.props.label}
          </span>
        );
      }

      return (
        <span>
          {label}
          {control}
        </span>
      );
    }
  }
);
